import { Observable } from 'rxjs';

export interface ICollectionPager<TModel> {
  data$: Observable<TModel[]>;
  onNext(): void;
}
